/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  cartAction,
  profileAction,
  orderAction,
  shopAction,
} from "@redux/modules";

// Form Validations
import { Formik } from 'formik';
import * as yup from 'yup';

import Form from 'react-bootstrap/Form';

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Toastify
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";
import GlobalLoader from "@components/GlobalLoader";
import OrderConsentCheck from "@components/OrderConsentCheck";

// Ürün/kategori bazında atanmış dinamik sipariş onay kutuları
import useOrderConsents from "@hooks/useOrderConsents";

// react-icons
import { FaTrashAlt, FaTrophy } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Sözleşme metinleri. FAZ 1 — geçici bilgilendirme; nihai hukuki metinler
// (avukattan) geldiğinde bu html içerikleri güncellenecek (FAZ 2).
const AGREEMENTS = {
  preInfo: {
    title: "Ön Bilgilendirme Koşulları",
    html: '<hr><h2>ÖN BİLGİLENDİRME KOŞULLARI</h2><h3>Bu bölümün içeriği hazırlanma aşamasındadır.<br><br>Sipariş ve ödeme koşullarına ilişkin nihai metin en kısa sürede burada yayımlanacaktır.<br><br>Sorularınız için <strong>0850 335 13 58</strong> numaralı Çağrı Merkezimize başvurabilirsiniz.</h3><hr>',
  },
  distanceSale: {
    title: "Mesafeli Satış Sözleşmesi",
    html: '<hr><h2>MESAFELİ SATIŞ SÖZLEŞMESİ</h2><h3>Bu bölümün içeriği hazırlanma aşamasındadır.<br><br>Sipariş ve ödeme koşullarına ilişkin nihai metin en kısa sürede burada yayımlanacaktır.<br><br>Sorularınız için <strong>0850 335 13 58</strong> numaralı Çağrı Merkezimize başvurabilirsiniz.</h3><hr>',
  },
};

const Cart = () => {
  const dispatch = useDispatch();
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  let cartData = useSelector((store) => store.cart.cartData);
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const addressData = useSelector((store) => store.profile.address);
  const isLoading = useSelector((store) => store.order.isLoading);
  const scoreCurrency = useSelector((store) => store.order.scoreCurrency);
  const minimumScoreRatioForPayment = useSelector(
    (store) => store.order.minimumScoreRatioForPayment
  );
  const paymentModule = useSelector((store) => store.cart.paymentModule);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validatedForm, setValidatedForm] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderSuccessTimer, setOrderSuccessTimer] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  // Açık sözleşme modalı: null | "preInfo" (Ön Bilgilendirme Koşulları) |
  // "distanceSale" (Mesafeli Satış Sözleşmesi)
  const [agreementModal, setAgreementModal] = useState(null);
  // Dinamik onay kutularında eksik onay uyarısını (kırmızı) göster.
  const [showConsentErrors, setShowConsentErrors] = useState(false);

  // Sepet satırlarına atanmış dinamik onay kutuları. Kural kategori veya tekil
  // ürün (SKU) seviyesinde tanımlanır; hangisinin uygulanacağını backend çözümler
  // (ürün > kategori). Atanmamışsa satırda kutu çıkmaz.
  const {
    isChecked: isConsentChecked,
    toggle: toggleConsent,
    missingCount: missingConsentCount,
    allAccepted: allConsentsAccepted,
    acknowledgements: consentAcknowledgements,
  } = useOrderConsents(cartData?.cartProductDTOList);

  const schema = yup.object({
    address: yup.string().required("Lütfen Adres Seçiniz!"),
    agreement: yup
      .bool()
      .required()
      .oneOf(
        [true],
        "Şartlar ve koşullar sözleşmelerini kabul etmek zorundasınız!"
      ),
    paymentAgreement: yup
      .bool()
      .required()
      .oneOf([true], "Ödeme sözleşmesini kabul etmek zorundasınız!"),
  });

  const formRef = useRef(null);

  useEffect(() => {
    dispatch(cartAction.getCart());
    dispatch(profileAction.getAddress());
    dispatch(orderAction.getScoreCurrency("ORDER"));
    dispatch(cartAction.getPaymentModule("SCORE_CURRENCY_CONVERSION"));

    return () => {};
  }, []);

  useEffect(() => {
    if (addressData && addressData.length > 0) {
      const filteredData = addressData
        .filter((address) => address.orderAddress === true)
        .map((filteredAddress) => filteredAddress.addressId);

      setSelectedAddress(filteredData[0]);
    }

    return () => {};
  }, [addressData]);

  const handleSubmitOrder = (values) => {
    // Form validasyonunu buraya ekleyelim
    if (!values.address || !values.agreement || !values.paymentAgreement) {
      showErrMessage(
        "Lütfen adres seçiniz, sözleşmeyi kabul ediniz ve ödeme sözleşmesini kabul ediniz!"
      );
      return;
    }

    // Ürüne/kategorisine atanmış onay kutuları işaretlenmeden sipariş ilerlemez.
    // Bu kutular genel şartlar / mesafeli satış sözleşmesi onayından ayrıdır.
    if (!allConsentsAccepted) {
      setShowConsentErrors(true);
      showErrMessage(
        missingConsentCount > 1
          ? `Sepetinizdeki ${missingConsentCount} ürün için gösterilen onayları vermeniz gerekmektedir.`
          : "Sepetinizdeki ürün için gösterilen onayı vermeniz gerekmektedir."
      );
      return;
    }

    //dispatch( cartAction.addToCart() );
    if (remainingAmount < 0 && values.address && values.paymentAgreement) {
      if (isScoreRatioInsufficient) {
        showErrMessage(
          `Ödemeye geçebilmek için mevcut puanınız en az ${Math.ceil(
            requiredMinimumScore
          )} olmalıdır.`
        );
        return;
      }

      const returnUrl = window.location.origin;

      setIsSubmitting(true);
      dispatch(
        orderAction.confirmPayment(
          values.address,
          true,
          returnUrl,
          consentAcknowledgements
        )
      )
        .then((e) => {
          if (e.isHttpSuccess && e.data.token) {
            localStorage.setItem("paymentToken", e.data.token);
            localStorage.setItem("isOrderForCatalog", true);
            showMessage(
              "Ödeme işlemi başlatıldı. Ödeme sayfasına yönlendiriliyorsunuz..."
            );
            dispatch(shopAction.getBrandCartList());
            dispatch(cartAction.getCart());
            //   setOrderSuccess(true);

            window.location.href = e.data.url;
            setTimeout(() => {
              setOrderSuccessTimer(true);
            }, 100);
          } else {
            showErrMessage("Ödeme işlemi başlatılamadı!");
          }
        })
        .catch((err) => {
          const errors = err?.error?.response?.data?.errors;
          if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((item) => {
              showErrMessage(item.message);
            });
          } else {
            showErrMessage(err?.message || "İşlem başarısız.");
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    } else {
      setIsSubmitting(true);
      dispatch(
        orderAction.createOrder(
          "EMPLOYEE",
          "KAMPANYA",
          selectedAddress,
          "test",
          false,
          values.agreement,
          consentAcknowledgements
        )
      )
        .then((e) => {
          if (e.isHttpSuccess) {
            localStorage.setItem("PayWithScore", true);
            // Hediye çeki siparişinde tamamlanma ekranı farklı (SMS ile kod gönderildi).
            if (e.data?.giftCardOrder) {
              localStorage.setItem("giftCardOrder", "true");
            } else {
              localStorage.removeItem("giftCardOrder");
            }

            showMessage(
              "Siparişiniz başarıyla alındı. Profil Siparişlerim sayfasından takip edebilirsiniz!"
            );
            window.location.href = "/order-summary";
            //setOrderSuccess(true);
            setTimeout(() => {
              dispatch(cartAction.getCart());
              //setOrderSuccessTimer(true);
            }, 4000);
          }
        })
        .catch((err) => {
          const errors = err?.error?.response?.data?.errors;
          if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((item) => {
              showErrMessage(item.message);
            });
          } else {
            showErrMessage(err?.message || "İşlem başarısız.");
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
    setValidatedForm(true);
  };

  const handleRemoveCartItem = (e, id) => {
    if (e !== null) {
      e.preventDefault();
    }

    dispatch(cartAction.removeCartItemById(id))
      .then((response) => {
        if (response.isHttpSuccess) {
          showMessage(`Ürün sepetten kaldırıldı!`);
          setTimeout(() => {
            dispatch(cartAction.getCart());
          }, 1000);
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          showErrMessage(`Üzgünüz. Ürün sepetten kaldırılamadı!`);
        }

        console.log("err: ", err);
      });
  };

  const handleMinus = (item) => {
    if (item.productCount > 1) {
      dispatch(
        shopAction.addToCart(item.product.id, item.productCount - 1, false)
      )
        .then((response) => {
          if (response.isHttpSuccess) {
            dispatch(cartAction.getCart());
          }
        })
        .catch((err) => {
          showErrMessage(err.message);
        });
    } else {
      handleRemoveCartItem(null, item.id);
    }
  };

  const handlePlus = (id, productCount, stock) => {
    if (productCount < stock) {
      dispatch(shopAction.addToCart(id, 1, true))
        .then((response) => {
          if (response.isHttpSuccess) {
            dispatch(cartAction.getCart());
          }
        })
        .catch((err) => {
          showErrMessage(err.message);
        });
    }
  };

  const handleRemoveAllItems = (e) => {
    // Form submit'i engellemek için
    e.preventDefault();
    e.stopPropagation();

    dispatch(cartAction.removeAllItems())
      .then((response) => {
        if (response.isHttpSuccess) {
          showMessage(`Tüm ürünler sepetten kaldırıldı!`);
          dispatch(cartAction.getCart());
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          showErrMessage(`Üzgünüz. Tüm ürünler sepetten kaldırılamadı!`);
        }
      });
  };

  const remainingAmount = profileDetail?.score - cartData?.totalScore;
  const paymentAmount = scoreCurrency * Math.abs(remainingAmount);

  // Minimum puan kontrolü (ürün bazlı ağırlıklı toplam):
  // Gereken puan = Σ (ürün puanı × adet × etkin oran / 100).
  // Etkin oran: ürünün kendi minimumScoreRatioForPayment'i varsa o; yoksa genel
  // (ScoreCurrencyConversion ORDER) değeri. Hiç oran yoksa gereken puan 0 → kontrol devre dışı.
  const requiredMinimumScore = (cartData?.cartProductDTOList || []).reduce(
    (sum, item) => {
      const productScore = Number(item?.product?.score) || 0;
      const count = Number(item?.productCount) || 0;
      const effectiveRatio =
        item?.product?.minimumScoreRatioForPayment != null
          ? Number(item.product.minimumScoreRatioForPayment)
          : Number(minimumScoreRatioForPayment) || 0;
      return sum + (productScore * count * effectiveRatio) / 100;
    },
    0
  );
  const isScoreRatioInsufficient =
    requiredMinimumScore > 0 &&
    (profileDetail?.score || 0) < requiredMinimumScore;

  // Etkin oran 100 ise ürün tamamen puan ile alınır; kart ile ödeme yapılamaz.
  // (Etkin oran: ürünün kendi minimumScoreRatioForPayment'i varsa o; yoksa genel
  // ORDER değeri — requiredMinimumScore ile aynı mantık.) Bu durumda kart tutarı
  // gizlenir, bilgilendirme metni güncellenir ve "Ödemeye Geç" yerine
  // "Siparişi Tamamla" gösterilir.
  const cartProducts = cartData?.cartProductDTOList || [];
  const isFullScorePayment =
    cartProducts.length > 0 &&
    cartProducts.every((item) => {
      const effectiveRatio =
        item?.product?.minimumScoreRatioForPayment != null
          ? Number(item.product.minimumScoreRatioForPayment)
          : Number(minimumScoreRatioForPayment) || 0;
      return effectiveRatio === 100;
    });

  return (
    <>
      <Header />

      <main>
        <section className="bg-blue py-5 mb-5">
          <div className="container">
            <h1 className="text-white mb-0 text-center">Sipariş Oluştur</h1>
          </div>
        </section>

        {cartData && cartData?.cartProductDTOList?.length > 0 ? (
          <section className="my-5">
            {orderSuccess ? (
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-7 col-md-10">
                    <div className="bg-gray-lightest rounded-3 p-5 text-center mb-5">
                      <h3 className="mb-5 text-green">
                        🎉 Siparişiniz Alındı!
                      </h3>
                      <p className="lead mb-5">
                        Hediyeniz <strong>15 iş günü</strong> içerisinde kargo
                        aracılığıyla size ulaşacaktır. İyi Günlerde Kullanın!
                      </p>
                      <Link
                        to="/profile/orders"
                        className="btn btn-green text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3"
                      >
                        Ödül Siparişlerim
                      </Link>
                    </div>
                    <p className="small fw-light opacity-75 text-center">
                      Siparişiniz ile ilgili sorularınız için Sıkça Sorulan
                      Sorular bölümünden yardım alabilir, Connection Çağrı
                      Merkezi'ni 0850 335 1358 nolu telefondan Pazartesi ila
                      Cuma günleri 09:00-18:00 saatleri arasında arayabilir veya
                      Bize Ulaşın'dan bize erişebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <Formik
                validationSchema={schema}
                onSubmit={(values, { resetForm }) =>
                  handleSubmitOrder(values, { resetForm })
                }
                initialValues={{
                  address: "",
                  agreement: false,
                  paymentAgreement: false,
                }}
                validate={(values) => {
                  const errors = {};
                  if (!values.address) {
                    errors.address = "Lütfen Adres Seçiniz!";
                  }
                  if (!values.agreement) {
                    errors.agreement =
                      "Şartlar ve koşullar sözleşmelerini kabul etmek zorundasınız!";
                  }
                  if (!values.paymentAgreement) {
                    errors.paymentAgreement =
                      "Ödeme sözleşmesini kabul etmek zorundasınız!";
                  }

                  return errors;
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <Form
                    ref={formRef}
                    className="form-address"
                    noValidate
                    onSubmit={(e) => {
                      if (
                        !values.address ||
                        !values.agreement ||
                        !values.paymentAgreement
                      ) {
                        e.preventDefault();
                        showErrMessage(
                          "Lütfen adres seçiniz, sözleşmeyi kabul ediniz ve ödeme sözleşmesini kabul ediniz!"
                        );
                      }
                      if (!allConsentsAccepted) {
                        setShowConsentErrors(true);
                      }
                      handleSubmit(e);
                    }}
                  >
                    <div className="container">
                      <div className="row justify-content-center gx-5 gy-5">
                        <div className="col-xl-8 col-lg-8">
                          <h5 className="mb-4 text-blue uppercase">Sepetim</h5>
                          {cartData && cartData.cartProductDTOList.length > 0
                            ? cartData.cartProductDTOList.map((item) => {
                                return (
                                  /* align-items-start: onay kutusundaki "Daha fazla
                                     bilgi al" paneli açılınca satır uzuyor; ortalı
                                     hizada görsel aşağı kayıyordu. */
                                  <div
                                    className="d-flex align-items-start border-bottom pb-5 mb-5"
                                    key={item.id}
                                  >
                                    {item?.product?.productContentUrlList &&
                                    item?.product?.productContentUrlList
                                      .length > 0 ? (
                                      <img
                                        src={
                                          item?.product
                                            ?.productContentUrlList[0]
                                            .baseAddress
                                        }
                                        alt=""
                                        className="img-contain rounded-3 shadow-lg"
                                        style={{
                                          width: "200px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          height: "150px",
                                          background: "#000",
                                        }}
                                      >
                                        {loginSettings?.logo && (
                                          <img
                                            src={loginSettings?.logo}
                                            alt=""
                                            className="w-100 opacity-50"
                                            style={{
                                              height: "150px",
                                              objectFit: "scale-down",
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}

                                    <div className="ms-4 d-flex w-100 flex-column">
                                      <h6>{item.product.name}</h6>
                                      {item.product.description ? (
                                        <p className="mt-3 mb-0 fw-light opacity-75">
                                          {item.product.description}
                                        </p>
                                      ) : null}

                                      <div>
                                        <div className="shopping-cart-point my-2 d-flex align-items-center w-100">
                                          <FaTrophy className="d-inline-block me-2 text-green" />
                                          <span className="d-inline-block">
                                            {item.product.score}
                                          </span>
                                          <div
                                            style={{
                                              marginLeft: "auto",
                                              fontSize: "20px",
                                            }}
                                            className="cursor-pointer text-red"
                                          >
                                            <FaTrashAlt
                                              className="text-red"
                                              onClick={(e) =>
                                                handleRemoveCartItem(e, item.id)
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center">
                                          <button
                                            type="button"
                                            style={{ fontSize: "24px" }}
                                            className="btn btn-outline-secondary btn-sm me-2 "
                                            onClick={() => handleMinus(item)}
                                          >
                                            -
                                          </button>
                                          <span
                                            style={{ fontSize: "20px" }}
                                            className="me-2"
                                          >
                                            {item.productCount}
                                          </span>
                                          <button
                                            type="button"
                                            style={{ fontSize: "24px" }}
                                            className="btn btn-outline-secondary btn-sm me-2"
                                            onClick={() =>
                                              handlePlus(
                                                item.product.id,
                                                item.productCount,
                                                item.product.stock
                                              )
                                            }
                                          >
                                            +
                                          </button>
                                        </div>

                                        {/* Ürüne/kategorisine atanmış dinamik
                                            onay kutusu. Atanmamışsa hiçbir şey
                                            çizilmez. */}
                                        <OrderConsentCheck
                                          consent={item.consent}
                                          checked={isConsentChecked(item.id)}
                                          onChange={(value) =>
                                            toggleConsent(item.id, value)
                                          }
                                          showError={showConsentErrors}
                                          inputId={`orderConsent-${item.id}`}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            : null}

                          <Form.Group controlId="changePasswordFormValidation">
                            <h5 className="mb-4 d-flex justify-content-between align-self-center">
                              <span className="text-blue">Teslimat Adresi</span>
                              <Link
                                to="/profile/address"
                                className="fs-6 text-green"
                              >
                                <small>Yeni Adres Ekle</small>
                              </Link>
                            </h5>

                            <div className="row gy-3 row-cols-md-1 row-cols-1 align-items-start">
                              <div className="col">
                                <Form.Control
                                  as="select"
                                  className="form-control"
                                  autoComplete="chrome-off"
                                  placeholder="Teslimat Adresi Seçiniz"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setSelectedAddress(e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                  name="address"
                                  value={values.address}
                                  isInvalid={
                                    touched.address && !!errors.address
                                  }
                                >
                                  <option value="">Seçiniz</option>
                                  {addressData?.map((item, i) => (
                                    <option value={item.addressId} key={i}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Form.Control>

                                <Form.Control.Feedback
                                  className="FeedBack"
                                  type="invalid"
                                >
                                  {errors.address &&
                                    touched.address &&
                                    errors.address}
                                </Form.Control.Feedback>
                              </div>

                              <Form.Group>
                                <Form.Label></Form.Label>
                                <Form.Check
                                  onChange={(e) => {
                                    handleChange(e);
                                    touched.paymentAgreement = true;
                                  }}
                                  onBlur={handleBlur}
                                  name="paymentAgreement"
                                  checked={values.paymentAgreement}
                                  isInvalid={
                                    touched.paymentAgreement &&
                                    !!errors.paymentAgreement
                                  }
                                  id="paymentAgreement"
                                  label={
                                    <>
                                      <a
                                        className="text-orange cursor-pointer text-decoration-underline"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setAgreementModal("preInfo");
                                        }}
                                      >
                                        Ön Bilgilendirme Koşulları
                                      </a>
                                      'nı okudum, onaylıyorum.
                                    </>
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.paymentAgreement &&
                                    touched.paymentAgreement &&
                                    errors.paymentAgreement}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <Form.Group>
                                <Form.Label></Form.Label>
                                <Form.Check
                                  onChange={(e) => {
                                    handleChange(e);
                                    touched.agreement = true;
                                  }}
                                  onBlur={handleBlur}
                                  name="agreement"
                                  checked={values.agreement}
                                  isInvalid={
                                    touched.agreement && !!errors.agreement
                                  }
                                  id="agreement"
                                  label={
                                    <>
                                      <a
                                        className="text-orange cursor-pointer text-decoration-underline"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setAgreementModal("distanceSale");
                                        }}
                                      >
                                        Mesafeli Satış Sözleşmesi
                                      </a>
                                      'ni okudum, onaylıyorum.
                                    </>
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.agreement &&
                                    touched.agreement &&
                                    errors.agreement}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          </Form.Group>
                        </div>

                        <div className="col-xl-4 col-lg-4">
                          <div className="bg-gray-lightest rounded-3 p-4">
                            <h5 className="mb-4">Sipariş Özeti</h5>
                            <div className="d-flex justify-content-between border-bottom py-3 small">
                              <div>Mevcut Puanınız</div>
                              <div>
                                {profileDetail?.score >= 1000
                                  ? profileDetail?.score.toLocaleString("tr-TR")
                                  : profileDetail?.score}
                              </div>
                            </div>
                            <div className="d-flex justify-content-between border-bottom py-3 small">
                              <div>Sipariş Tutarı (Puan)</div>
                              <div>
                                {cartData?.totalScore >= 1000
                                  ? cartData?.totalScore.toLocaleString("tr-TR")
                                  : cartData?.totalScore}
                              </div>
                            </div>

                            {remainingAmount < 0 &&
                              paymentModule &&
                              !isFullScorePayment && (
                                <div className="d-flex justify-content-between py-3 small text-blue">
                                  <div>Kartınızdan tahsil edilecek tutar</div>
                                  <div>
                                    {paymentAmount >= 1000
                                      ? paymentAmount.toLocaleString("tr-TR", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      : paymentAmount.toFixed(2)}{" "}
                                    TL
                                  </div>
                                </div>
                              )}

                            {remainingAmount < 0 &&
                              paymentModule &&
                              isScoreRatioInsufficient && (
                                <div className="text-red small mt-3">
                                  {isFullScorePayment
                                    ? "Mevcut puanınız, sepetiniz için gereken minimum puanın altında."
                                    : "Ödemeye geçebilmek için mevcut puanınız, sepetiniz için gereken minimum puanın altında."}
                                  <br />
                                  (Gerekli puan:{" "}
                                  {Math.ceil(
                                    requiredMinimumScore
                                  ).toLocaleString("tr-TR")}
                                  , mevcut puanınız:{" "}
                                  {(profileDetail?.score || 0).toLocaleString(
                                    "tr-TR"
                                  )}
                                  )
                                </div>
                              )}

                            {!allConsentsAccepted && (
                              <div className="text-red small mt-3">
                                Sepetinizde onaylamanız gereken{" "}
                                {missingConsentCount} ürün bulunuyor. Ürünün
                                altındaki onay kutusunu işaretlemeden siparişi
                                tamamlayamazsınız.
                              </div>
                            )}

                            {remainingAmount < 0 &&
                              paymentModule &&
                              !isFullScorePayment && (
                                <button
                                  type="submit"
                                  disabled={
                                    isScoreRatioInsufficient || isSubmitting
                                  }
                                  className="btn btn-blue text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3 mt-4 w-100"
                                >
                                  Ödemeye Geç
                                </button>
                              )}
                            {(remainingAmount >= 0 || isFullScorePayment) && (
                              <button
                                type="submit"
                                disabled={
                                  isSubmitting ||
                                  (isFullScorePayment &&
                                    isScoreRatioInsufficient)
                                }
                                className="btn btn-green text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3 mt-4 w-100"
                              >
                                Siparişi Tamamla
                              </button>
                            )}
                            <button
                              type="button"
                              disabled={isSubmitting}
                              className="btn btn-red-danger text-white rounded-pill w-100 mt-2"
                              onClick={handleRemoveAllItems}
                            >
                              Tüm Ürünleri Kaldır
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </section>
        ) : (
          <section className="my-sm-10 my-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-7 col-md-10">
                  <div className="bg-gray-lightest rounded-3 p-5 text-center mb-5">
                    <h3 className="mb-5 text-red">🛒 Sepetiniz Boş!</h3>
                    <p className="lead mb-5">
                      Şu anda sepetinizde ürün bulunmamaktadır. Alışverişe devam
                      etmek için mağazamızı ziyaret edebilirsiniz.
                    </p>
                    <Link
                      to="/shop"
                      className="btn btn-blue text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3"
                    >
                      Alışverişe Devam Et
                    </Link>
                  </div>
                  <p className="small fw-light opacity-75 text-center">
                    Siparişiniz ile ilgili sorularınız için Sıkça Sorulan
                    Sorular bölümünden yardım alabilir, Connection Çağrı
                    Merkezi'ni 0850 335 1358 nolu telefondan Pazartesi ila Cuma
                    günleri 09:00-18:00 saatleri arasında arayabilir veya Bize
                    Ulaşın'dan bize erişebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <Footer />
      <GlobalLoader isLoading={isLoading} />

      {/* Sözleşme Modalı (Ön Bilgilendirme Koşulları / Mesafeli Satış Sözleşmesi) */}
      <Modal
        show={!!agreementModal}
        onHide={() => setAgreementModal(null)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {agreementModal ? AGREEMENTS[agreementModal].title : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="agreement-content"
            style={{ maxHeight: "400px", overflowY: "auto" }}
            dangerouslySetInnerHTML={{
              __html: agreementModal ? AGREEMENTS[agreementModal].html : "",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAgreementModal(null)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Cart;
